import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SelectTrigger } from '@ui/SelectTrigger';

type PresetDropdownProps = {
  label: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  truncate?: boolean;
};

/** Scope panel trigger in the center scope-selector card. */
export const PresetDropdown: React.FC<PresetDropdownProps> = ({
  label,
  open,
  onToggle,
  truncate = false,
}) => {
  const { classes, cx } = useStyles();
  // Keep the tooltip controlled for its whole lifetime; MUI warns when `open`
  // switches between undefined and a boolean.
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // Opening the panel hides the tooltip; drop its state so it cannot reappear
  // when the panel closes with the pointer elsewhere.
  if (open && tooltipOpen) setTooltipOpen(false);
  return (
    <Tooltip
      title="Scope"
      placement="bottom"
      disableHoverListener={open}
      disableFocusListener={open}
      open={!open && tooltipOpen}
      onOpen={() => {
        if (!open) setTooltipOpen(true);
      }}
      onClose={() => setTooltipOpen(false)}
    >
      <span className={cx(truncate && classes.constrained)}>
        <SelectTrigger
          value={label}
          valueClassName={classes.value}
          open={open}
          onClick={onToggle}
        />
      </span>
    </Tooltip>
  );
};

const useStyles = makeStyles()(() => ({
  value: {
    fontWeight: 500,
    letterSpacing: '0.5px',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  constrained: {
    display: 'block',
    minWidth: 0,
    maxWidth: '100%',
    '& > button': { maxWidth: '100%' },
    '& p': {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
}));
